if ( $('.about-block').length ) {

    var aboutLeader = document.getElementById("aboutLeader"),
        aboutLeaderCanvas = aboutLeader.getContext('2d'),
        brushRadius = (aboutLeader.width / 100) * 5,
        img = new Image();

    if (brushRadius < 50) {
        brushRadius = 50
    }

    img.onload = function(){  
        aboutLeaderCanvas.drawImage(img, 0, 0, aboutLeader.width, aboutLeader.height);
        $('#aboutBlock').addClass('is-visible');
    }
    img.loc = '';
    img.filename = '/assets/images/leaders/leader-about-frosted1.jpg';
    img.src = img.loc + img.filename;

    function detectLeftButton(event) {
        if ('buttons' in event) {
            return event.buttons === 1;
        } else if ('which' in event) {
            return event.which === 1;
        } else {
            return event.button === 1;
        }
    }

    function getBrushPos(xRef, yRef) {
        var aboutLeaderRect = aboutLeader.getBoundingClientRect();
        return {
            x: Math.floor((xRef-aboutLeaderRect.left)/(aboutLeaderRect.right-aboutLeaderRect.left)*aboutLeader.width),
            y: Math.floor((yRef-aboutLeaderRect.top)/(aboutLeaderRect.bottom-aboutLeaderRect.top)*aboutLeader.height)
        };
    }
          
    function drawDot(mouseX,mouseY){
        aboutLeaderCanvas.beginPath();
        aboutLeaderCanvas.arc(mouseX, mouseY, brushRadius, 0, 2*Math.PI, true);
        aboutLeaderCanvas.fillStyle = '#000';
        aboutLeaderCanvas.globalCompositeOperation = "destination-out";
        aboutLeaderCanvas.fill();
    }

    aboutLeader.addEventListener("mousemove", function(e) {
        var brushPos = getBrushPos(e.clientX, e.clientY);
        var leftBut = detectLeftButton(e);

        drawDot(brushPos.x, brushPos.y);

        // if (leftBut == 1) {
        //     drawDot(brushPos.x, brushPos.y);
        // }
    }, false);

    aboutLeader.addEventListener("touchmove", function(e) {
        e.preventDefault();
        var touch = e.targetTouches[0];
        
        if (touch) {
            var brushPos = getBrushPos(touch.pageX, touch.pageY);
            drawDot(brushPos.x, brushPos.y);
        }
    }, false);


    // clear frosted glass on mobile
    if ($(window).width() <= 992) {
        img.onload = function() {
            aboutLeaderCanvas.clearRect(0, 0, aboutLeader.width, aboutLeader.height);
        }
    }

    $(document).mousemove(function(e) {
        if( e.target.id=="aboutLeader") {

            var totalDistance = 0;
            var cursorX, cursorY;
            
            $(this).mousemove(function(e) {

                // mouse moving
                var cursorThreshold = 2500;

                if (cursorX) totalDistance += Math.sqrt(Math.pow(cursorY - e.clientY, 2) + Math.pow(cursorX - e.clientX, 2));
                    if (totalDistance >= cursorThreshold) {
                        $('#aboutLeader').addClass('canvas-hidden');
                        $(document).off('mousemove');

                        // scroll page down after all 5 services have been selected
                        setTimeout(function() { 
                            $('html, body').animate({
                                scrollTop: $('#aboutBlock').offset().top + 400
                            }, 500);
                        }, 2000);

                        totalDistance = 0;
                    }
                
                    cursorX = e.clientX;
                    cursorY = e.clientY;

            })

        }
    })
}

// fades out frost after scroll
$(window).scroll(function() {
    aboutLeader = $('#aboutLeader');

    if ($(window).width() >= 992 && aboutLeader.length) {

        if ($(this).scrollTop() > 300) {
            aboutLeader.addClass('canvas-hidden');
            $(document).off('mousemove');
        }
    }
});
